import React from "react";
import Wrapper from "./cancelled-shift-placeholder.styles";

export default function CancelledShiftPlaceholder() {
  return <Wrapper>This shift is cancelled</Wrapper>;
}
